import * as React from "react";
import { useEffect, useState } from "react";
import { styled,  Theme, CSSObject } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import { Box, useTheme, useMediaQuery,Tooltip } from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import MeetingIcon from '../../SidebarIcons/meeting.svg';
import MenuuIcon from "@mui/icons-material/Menu"; // آیکن برای باز کردن منو
import CloseeIcon from "@mui/icons-material/Close"; // آیکن برای بستن منو
import DashboardIcoon from '@mui/icons-material/Dashboard';
import Meet1Icon from '../../SidebarIcons/agreement.svg';
import Meet13Icon from '../../SidebarIcons/coworking-_1_.svg';
import teamIcon from '../../SidebarIcons/team.svg';
import unitedIcon from '../../SidebarIcons/united.svg';
import corporateIcon from '../../SidebarIcons/corporate-building.svg';
import FolderIcon from '../../SidebarIcons/okr.svg'; 
import VerticalIcon from '../../SidebarIcons/vertical-alignment.svg'; 
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BusinessIcon from '../../SidebarIcons/business_1.svg'; 
import Meet10Icon from '../../SidebarIcons/conference.svg'; 
import Meet11Icon from '../../SidebarIcons/meeting-room.svg'; 
import Meet0Icon from '../../SidebarIcons/IMG_20241107_181207_268.svg'; 
import Meet111Icon from '../../SidebarIcons/IMG_20241107_181205_944.svg'; 
import Meet21Icon from '../../SidebarIcons/training.svg'; 
import Meet12Icon from '../../SidebarIcons/round-table-_1_.svg'; 
import HierarchyIcon from '../../SidebarIcons/hierarchy.svg'; 
import CompanyIcon from '../../SidebarIcons/svgviewer-output.svg'; 
import BankIcon from '../../SidebarIcons/bank.svg'; 
import OptimizatiomIcon from '../../SidebarIcons/BAU.svg'; 
import TestingIcon from '../../SidebarIcons/2362166.svg'; 
import BulletIcon from '../../SidebarIcons/bullet-analysis.svg'; 
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useNavigate } from 'react-router-dom';
import Button from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import menuIcon from "../../SidebarIcons/menu.svg";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import SettingsIcon from "@mui/icons-material/Settings";
import VerticalAlignBottomIcon from "@mui/icons-material/FileDownload";  
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications"; 
import DashboardIcon from "@mui/icons-material/DashboardSharp";
import AllIcon from "@mui/icons-material/Analytics";
import HAIcon from "@mui/icons-material/MarkChatRead";
import AIcon from "@mui/icons-material/EventNote";
import OKIcon from "@mui/icons-material/InsertComment";
import ChatRounded from "@mui/icons-material/ChatRounded";
import GuideIcon from "@mui/icons-material/Help";
import DescriptionIcon from '@mui/icons-material/Description';
import TenantsList from "./LComponents/TenantList/TenantList";
import UserTypeSelection from "../../scenes/Meeting/LComponents/UserTypeSelection/UserTypeSelection";
import PersonOutlineOutlined from "@mui/icons-material/Person";
import ReportIcon from "@mui/icons-material/CreditCard";  
import RepotIcon from "@mui/icons-material/Dehaze"; 
import { Link, Outlet, useLocation } from "react-router-dom";
import { SideBarLogo, OKRtext } from "./StaticsData/index";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { ReactComponent as BaseInfoIcon } from "./StaticsData/Icons/BaseInfoIcon.svg";
import { ReactComponent as CompanyManagmentIcon } from "./StaticsData/Icons/companyManagmentIcon.svg";
import OKRIcon from "@mui/icons-material/Dataset";
import ExitIcon from "@mui/icons-material/ExitToApp";
import AboutUsIcon from "@mui/icons-material/Info";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useAuth } from "../../Context/AuthProvider";
import { useDispatch } from "react-redux";
import { resetRValuesR } from "../../scenes/Meeting/MeetingsSlice/MeetingsSlice";
import { useSelector } from "react-redux";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Badge, FormControl, InputLabel, MenuItem } from "@mui/material";
import { MUIWrapperContext } from "../../ThemeWrapper/ThemeWrapper";
import Menu from '@mui/material/Menu';
import sendIcon from "../../SidebarIcons/send.svg";
import strategyIcon from "../../SidebarIcons/strategy.svg";
import roadmapIcon from "../../SidebarIcons/roadmap.svg";
import implementationIcon from "../../SidebarIcons/implementation.svg";  // map


const drawerWidth = 230;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const itemsList = [
  // {
  //   text: "داشبورد",
  //   icon: <DashboardIcon  />,
  //   to: "/dashboard/dashboard"
  // }
  // ,
  {
    text: "داشبورد",
    icon: <DashboardIcon fontSize="large" />,
    to: "/dashboard/TenantDash",
  },
  {
    text: "بانک شاخص",
    // icon: <BankIcon fontSize="large" />,
    to: "/dashboard/IndexBank",
  }, 

  {
    text: "هدف نهایی و استراتژی",
    icon: <HAIcon fontSize="large" />,
    to: "/dashboard/MissionAndStrategy",
  },
];

export default function MiniDrawer() {
  const [activeIndex, setActiveIndex] = React.useState<number>(1);
  const isLandscape = useMediaQuery("(orientation: landscape)"); // تشخیص حالت افقی موبایل

  const { locale, setLocale, toggleColorMode }: any =
    React.useContext(MUIWrapperContext);

  const [showTenantItem, setShowTenantItem] = React.useState(false);
  const userPhone = useSelector((state: any) => state.loign.userPhoneNumber);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [selectedIndexx, setSelectedIndexx] = React.useState(1);
  const location = useLocation();
  const { pathname } = location;

  let meetingRoute = pathname.includes("TenantDash");

  useEffect(() => {
    const menuIdx = itemsList.findIndex((item) => item.to === pathname);
    if (menuIdx > -1) setActiveIndex(menuIdx);
  }, [pathname]);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index);
  };
  const handleListItemClickk = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndexx(index);
  };
  const [open, setOpen] = React.useState(true);

  const handleClick = (event: any) => {
    handleListItemClick(event, 0);
    setOpenItem(!openItem);
  };

  const tenantList = useSelector(
    (state: any) => state.loign.userInfo.userTenants
  );
  const pictureBase64String = useSelector(
    (state: any) => state.meetings.pictureBase64String
  );
  const tenantName = useSelector((state: any) => state.meetings.profileName);
  const dispatch = useDispatch();
  const newAuth = useAuth();
  const theme = useTheme();
  const [openItem, setOpenItem] = React.useState(false);
  const [openItemm, setOpenItemm] = React.useState(false);
  const [openItemmm, setOpenItemmm] = React.useState(false);
  const [openItemmmm, setOpenItemmmm] = React.useState(false);
  const [openItemmmmm, setOpenItemmmmm] = React.useState(false);

  const [imgSrc, setImgSrc] = useState<any>(null);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const personName = useSelector((state: any) => state.loign.name);
  const personPicture = useSelector((state: any) => state.loign.picture);
  const isMobilee = useMediaQuery('(max-width:600px)');  // اندازه موبایل را تعیین می‌کنیم
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen); // تغییر وضعیت باز و بسته شدن سایدبار
  };
  // تابع برای بستن سایدبار
  const handleDrawerClose = () => {
      setOpen(false); // بستن Drawer
      setOpenItemm(false); // بستن زیرآیتم‌های "مدیریت OKR"
      setOpenItemmm(false); // بستن زیرآیتم‌های "مدیریت OKR"
    };

  // وقتی در حالت موبایل هستیم، به طور پیش‌فرض سایدبار بسته باشد
  useEffect(() => {
    if (isMobilee) {
      handleDrawerClose(); // اگر موبایل بود، سایدبار به طور پیش‌فرض بسته می‌شود
    }
  }, [isMobilee]);  // تنها زمانی که وضعیت isMobile تغییر کند این کار انجام می‌شود
  var date = new DateObject({ calendar: persian, locale: persian_fa });
  date.calendar = persian;
  date.locale = persian_fa; //جمعه 31 مرداد
  const now = date.format("dddd DD MMMM  ");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // برای موبایل حالت بسته می‌شود

  const initiaLogOut = () => {
    newAuth.logout();
    localStorage.setItem("accessToken", "");
    dispatch(resetRValuesR());
  };

  useEffect(() => {
    if (personPicture) {
      setImgSrc(personPicture);
    }
  }, [personPicture]);
  const navigate=useNavigate()
  const goProfile=()=>{

    navigate("/dashboard/companyManagment/profile")
    handleMenuClose()
}
const goChat=()=>{

  navigate("/dashboard/chat")
  handleMenuClose()
}
const gosettings=()=>{

  navigate("/dashboard/settings")
  handleMenuClosee()

}
const gohelpsoftware=()=>{

  navigate("/dashboard/helpsoftware/index")
  handleMenuCloseee()

}
const goReleaseNotesTitle=()=>{

  navigate("/dashboard/Helpsoftware/ReleaseNotesTitle")
  handleMenuCloseee()

}
const goaboutus=()=>{

  navigate("/dashboard/aboutus")
  handleMenuCloseee()

}
const goIndexManagment=()=>{

  navigate("/dashboard/indexManagment")
  handleMenuCloseeeee()
}

const gotenants=()=>{

  navigate("/dashboard/tenants")
  handleMenuCloseeeee()
}

const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
React.useState<null | HTMLElement>(null);
const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
  setMobileMoreAnchorEl(event.currentTarget);  
};
const [mobileMoreAnchorEll, setMobileMoreAnchorEll] =
React.useState<null | HTMLElement>(null);
const handleMobileMenuOpenn = (event: React.MouseEvent<HTMLElement>) => {
  setMobileMoreAnchorEll(event.currentTarget);  
};
const [mobileMoreAnchorElll, setMobileMoreAnchorElll] =
React.useState<null | HTMLElement>(null);
const handleMobileMenuOpennn = (event: React.MouseEvent<HTMLElement>) => {
  setMobileMoreAnchorElll(event.currentTarget);  
};
const [mobileMoreAnchorEllll, setMobileMoreAnchorEllll] =
React.useState<null | HTMLElement>(null);
const handleMobileMenuOpennnn = (event: React.MouseEvent<HTMLElement>) => {
  setMobileMoreAnchorEllll(event.currentTarget);  
};
const [mobileMoreAnchorElllll, setMobileMoreAnchorElllll] =
React.useState<null | HTMLElement>(null);
const handleMobileMenuOpennnnn = (event: React.MouseEvent<HTMLElement>) => {
  setMobileMoreAnchorElllll(event.currentTarget);  
};
const menuId = 'primary-search-account-menu';
const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
const [anchorEll, setAnchorEll] = React.useState<null | HTMLElement>(null);
const [anchorElll, setAnchorElll] = React.useState<null | HTMLElement>(null);
const [anchorEllll, setAnchorEllll] = React.useState<null | HTMLElement>(null);
const [anchorElllll, setAnchorElllll] = React.useState<null | HTMLElement>(null);

const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
  setAnchorEl(event.currentTarget);
};
const handleProfileMenuOpenn = (event: React.MouseEvent<HTMLElement>) => {
  setAnchorEll(event.currentTarget);
};
const handleProfileMenuOpennn = (event: React.MouseEvent<HTMLElement>) => {
  setAnchorElll(event.currentTarget);
};
const handleProfileMenuOpennnn = (event: React.MouseEvent<HTMLElement>) => {
  setAnchorEllll(event.currentTarget);
};
const handleProfileMenuOpennnnn = (event: React.MouseEvent<HTMLElement>) => {
  setAnchorElllll(event.currentTarget);
};
const handleMobileMenuClose = () => {
  setMobileMoreAnchorEl(null);
};
const handleMobileMenuClosee = () => {
  setMobileMoreAnchorEll(null);
};
const handleMobileMenuCloseee = () => {
  setMobileMoreAnchorElll(null);
};
const handleMobileMenuCloseeee = () => {
  setMobileMoreAnchorEllll(null);
};
const handleMobileMenuCloseeeee = () => {
  setMobileMoreAnchorElllll(null);
};

const isMenuOpen = Boolean(anchorEl);
const isMenuOpenn = Boolean(anchorEll); 
const isMenuOpennn = Boolean(anchorElll); 
const isMenuOpennnn = Boolean(anchorEllll);
const isMenuOpennnnn = Boolean(anchorElllll); 
const handleMenuClose = () => {
  setAnchorEl(null);
  handleMobileMenuClose();
};
const handleMenuClosee = () => {
  setAnchorEll(null);
  handleMobileMenuClosee();
};
const handleMenuCloseee = () => {
  setAnchorElll(null);
  handleMobileMenuCloseee();
};
const handleMenuCloseeee = () => {
  setAnchorEllll(null);
  handleMobileMenuCloseeee();
};
const handleMenuCloseeeee = () => {
  setAnchorElllll(null);
  handleMobileMenuCloseeeee();
};

useEffect(() => {
  const path = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const index = queryParams.get('activeIndex');

  if (index) {
    setActiveIndex(parseInt(index, 10));
  } else {
    switch (path) {
      case '/dashboard/IndexBank':
        setActiveIndex(18);
        break;
      case '/dashboard/okrManagment':
        setActiveIndex(11);
        break;
      case '/dashboard/meetings':
        setActiveIndex(15);
        break;
      case '/dashboard/alignmentMeeting':
        setActiveIndex(30);
        break;
      case '/dashboard/okrManagment/objectiveDetails':
        setActiveIndex(11);
        break;
      case '/dashboard/LoginMeeting':
        setActiveIndex(15);
        break;
      default:
        setActiveIndex(25); // پیش‌فرض روی داشبورد
    }
  }
}, [location]);

const [activeSubMenu, setActiveSubMenu] = useState<number | null>(null);
const [opent, setOpent] = useState(false); // مدیریت وضعیت نمایش تولتیپ در حالت موبایل
const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);

const handleOpent = () => {
  setOpent(true);
};

const handleCloset = () => {
  setOpent(false);
};
const handleItemClick = (event: React.MouseEvent, index: number, path: string) => {
  event.preventDefault();
  if (window.innerWidth <= 600) { // فقط در موبایل
    setIsSidebarOpen(false);
  }
  setActiveIndex(index);
  navigate(`${path}?activeIndex=${index}`);

  if ((index >= 11 && index <= 13) || index === 1002 || index === 1001) {
    setActiveSubMenu(11); // or any number between 11 and 13
    setOpenItemm(true); // Open OKR management menu
    setOpenItemmm(false); // Close item 15 menu
    return;
  }

  if (index === 15) {
    setActiveSubMenu(15);
    setOpenItemmm(true); // Open item 15 menu
    setOpenItemm(false); // Close OKR management menu
    return;
  }

  if (index === 30) {
    setActiveSubMenu(30);
    setOpenItemmm(true); // Open item 15 menu
    setOpenItemm(false); // Close OKR management menu
    return;
  }
  if (index === 20 || index === 1003) {
    setActiveSubMenu(20);
    setOpenItemmmm(true); // Open item 15 menu
    setOpenItemmm(false); // Open item 15 menu
    setOpenItemm(false); // Close OKR management menu
    return;
  }
  if (index === 17) {
    setActiveSubMenu(17);
    setOpenItemmmmm(true); // Open item 15 menu
    setOpenItemmmm(false); // Open item 15 menu
    setOpenItemmm(false); // Open item 15 menu
    setOpenItemm(false); // Close OKR management menu
    return;
  }
  if (index === 33) {
    setActiveSubMenu(33);
    setOpenItemmmmm(true); // Open item 15 menu
    setOpenItemmmm(false); // Open item 15 menu
    setOpenItemmm(false); // Open item 15 menu
    setOpenItemm(false); // Close OKR management menu
    return;
  }  if (index === 34) {
    setActiveSubMenu(34);
    setOpenItemmmmm(true); // Open item 15 menu
    setOpenItemmmm(false); // Open item 15 menu
    setOpenItemmm(false); // Open item 15 menu
    setOpenItemm(false); // Close OKR management menu
    return;
  }

  // If clicking an item outside the OKR management or item 15, close both menus
  setOpenItemm(false);
  setOpenItemmm(false);
  setOpenItemmmm(false);
  setOpenItemmmmm(false);
};

const isOKRManagementOpen = activeSubMenu === 11 || activeSubMenu === 12 || activeSubMenu === 13 || activeSubMenu === 1001 || activeSubMenu === 1002;
const isItem15Open = activeSubMenu === 15;

// const handleClickk = (event: React.MouseEvent) => {
//   setOpen(true); // باز کردن Drawer
//   setOpenItemm((prev) => !prev); // آیتم اول را باز و بسته می‌کند
//   if (!openItemm) setOpenItemmm(false); // آیتم دوم را می‌بندد اگر اولی باز شد
// };
const handleClickk = (event: React.MouseEvent) => {
  if (isMobile) {
    setOpenItemm((prev) => !prev); // فقط آیتم انتخابی باز یا بسته می‌شود
    if (!openItemm) {
      setOpenItemmm(false); // آیتم دوم را می‌بندد اگر اولی باز شد
      setOpenItemmmm(false); // آیتم سوم را می‌بندد اگر اولی باز شد
      setOpenItemmmmm(false); // آیتم چهارم را می‌بندد اگر اولی باز شد
    }
  } else {
    setOpen(true); // باز کردن Drawer برای دسکتاپ
    setOpenItemm((prev) => !prev); // آیتم اول را باز و بسته می‌کند
    if (!openItemm) {
      setOpenItemmm(false); // آیتم دوم را می‌بندد اگر اولی باز شد
      setOpenItemmmm(false); // آیتم سوم را می‌بندد اگر اولی باز شد
      setOpenItemmmmm(false); // آیتم چهارم را می‌بندد اگر اولی باز شد
    }
  }
};

const handleClickkk = (event: React.MouseEvent) => {
  if (isMobile) {
    setOpenItemmm((prev) => !prev); // فقط آیتم انتخابی باز یا بسته می‌شود
    if (!openItemmm) {
      setOpenItemm(false); // آیتم اول را می‌بندد اگر دومی باز شد
      setOpenItemmmm(false); // آیتم سوم را می‌بندد اگر دومی باز شد
      setOpenItemmmmm(false); // آیتم چهارم را می‌بندد اگر دومی باز شد
    }
  } else {
    setOpen(true); // باز کردن Drawer برای دسکتاپ
    setOpenItemmm((prev) => !prev); // آیتم دوم را باز و بسته می‌کند
    if (!openItemmm) {
      setOpenItemm(false); // آیتم اول را می‌بندد اگر دومی باز شد
      setOpenItemmmm(false); // آیتم سوم را می‌بندد اگر دومی باز شد
      setOpenItemmmmm(false); // آیتم چهارم را می‌بندد اگر دومی باز شد
    }
  }
};

const handleClickkkk = (event: React.MouseEvent) => {
  if (isMobile) {
    setOpenItemmmm((prev) => !prev); // فقط آیتم انتخابی باز یا بسته می‌شود
    if (!openItemmmm) {
      setOpenItemm(false); // آیتم اول را می‌بندد اگر سومی باز شد
      setOpenItemmm(false); // آیتم دوم را می‌بندد اگر سومی باز شد
      setOpenItemmmmm(false); // آیتم چهارم را می‌بندد اگر سومی باز شد
    }
  } else {
    setOpen(true); // باز کردن Drawer
    setOpenItemmmm((prev) => !prev); // آیتم سوم را باز و بسته می‌کند
    if (!openItemmmm) {
      setOpenItemm(false); // آیتم اول را می‌بندد اگر سومی باز شد
      setOpenItemmm(false); // آیتم دوم را می‌بندد اگر سومی باز شد
      setOpenItemmmmm(false); // آیتم چهارم را می‌بندد اگر سومی باز شد
    }
  }
};

const handleClickkkkk = (event: React.MouseEvent) => {
  if (isMobile) {
    setOpenItemmmmm((prev) => !prev); // فقط آیتم انتخابی باز یا بسته می‌شود
    if (!openItemmmmm) {
      setOpenItemm(false); // آیتم اول را می‌بندد اگر چهارمی باز شد
      setOpenItemmm(false); // آیتم دوم را می‌بندد اگر چهارمی باز شد
      setOpenItemmmm(false); // آیتم سوم را می‌بندد اگر چهارمی باز شد
    }
  } else {
    setOpen(true); // باز کردن Drawer
    setOpenItemmmmm((prev) => !prev); // آیتم چهارم را باز و بسته می‌کند
    if (!openItemmmmm) {
      setOpenItemm(false); // آیتم اول را می‌بندد اگر چهارمی باز شد
      setOpenItemmm(false); // آیتم دوم را می‌بندد اگر چهارمی باز شد
      setOpenItemmmm(false); // آیتم سوم را می‌بندد اگر چهارمی باز شد
    }
  }
};


const [isSidebarOpenn, setSidebarOpenn] = React.useState(true);

const handleCloseSidebar = () => {
  setSidebarOpenn(false); // بستن سایدبار
};

  if (showTenantItem) {
    return <UserTypeSelection changeT={setShowTenantItem} />;
  }
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar
          sx={{
            height: "100%",
            width: "100%",
            bgcolor: theme.palette.mode === "dark" ? "#1E1E1E" : "whitesmoke",
            display: "flex",
            justifyContent: "space-between", // Align items properly
            flexDirection: { xs: "column", sm: "row" }, // Stack items on mobile, row on larger screens
          }}
        >
{/* <IconButton
  color="inherit"
  aria-label="open drawer"
  onClick={handleDrawerOpen}
  edge="start"
  sx={{
    marginRight: 5,
    color: 
    theme.palette.mode === "dark" ? "white" : "black",
    ...(open && { display: "none" }), // مخفی کردن آیکون زمانی که Drawer باز است
    display: { xs: "none", sm: open ? "none" : "flex" }, // در موبایل مخفی باشد، در وب زمانی که Drawer بسته است نمایش داده شود
  }}
>
  <MenuIcon />
</IconButton> */}
    <IconButton
      color="inherit"
      aria-label="open drawer"
      onClick={handleDrawerOpen}
      edge="start"
      sx={{
        marginRight: 5,
        color: theme.palette.mode === "dark" ? "white" : "black",
        ...(open && { display: "none" }), // مخفی کردن آیکون زمانی که Drawer باز است
        display: { xs: "none", sm: open ? "none" : "flex" }, // در موبایل مخفی باشد، در وب زمانی که Drawer بسته است نمایش داده شود
      }}
    >
      <MenuIcon />
    </IconButton>
          <Box width={"100%"} display={"flex"} 
          flexDirection={"row-reverse"}>
            <Box display={"flex"} justifyContent={"end"} width={"100%"}>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpennnn}
              color="inherit"
            > <Typography color={'gray'}>
         <VerticalAlignBottomIcon  />
         </Typography>
                </IconButton>
            <Menu
      anchorEl={anchorEllll}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={isMenuOpennnn}
      onClose={handleMenuCloseeee}
    >
      <MenuItem >
      <Typography color={"gray"}  fontSize={'13px'} fontWeight={800}> <VerticalAlignBottomIcon />
      <a href="https://play.google.com/store/apps/details?id=com.okr.coach.okr_coach&hl=en&gl=US&pli=1" target="-blank"> نسخه موبایل- اندروید </a> </Typography> 
      </MenuItem>
      <Divider variant="middle" />
      <MenuItem>
      <Typography color={"gray"}  fontSize={'13px'} fontWeight={800}>  <VerticalAlignBottomIcon />  
      <a href="https://mobile.ebrazonline.ir/" target="-blank">  نسخه موبایل- pwa برای iOS</a> </Typography> 
      </MenuItem>
      </Menu>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpenn}
              color="inherit"
            > <Typography color={'gray'}>
         <SettingsIcon />
         </Typography>
                </IconButton>
            <Menu
      anchorEl={anchorElll}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={isMenuOpennn}
      onClose={handleMenuCloseee}
    >
      <MenuItem onClick={gohelpsoftware}>
      <Typography color={"gray"} fontSize={'13px'} fontWeight={800}> <GuideIcon /> راهنمای نرم افزار </Typography> 
      </MenuItem>
      <Divider variant="middle" />
         <MenuItem onClick={goaboutus}>
      <Typography color={"gray"} fontSize={'13px'} fontWeight={800}> <AboutUsIcon /> درباره ما </Typography> 
      </MenuItem>
      <Divider variant="middle" />
      <MenuItem onClick={goReleaseNotesTitle}>
      <Typography color={"gray"} fontSize={'13px'} fontWeight={800}> <DescriptionIcon /> یادداشت‌های نسخه </Typography> 
      </MenuItem>
                  </Menu>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpennn}
              color="inherit"
            > <Typography color={'gray'}>
            <GuideIcon />        
            </Typography>
                </IconButton>
            <Menu
      anchorEl={anchorEll}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={isMenuOpenn}
      onClose={handleMenuClosee}
    >
      <MenuItem onClick={gosettings}>
      <Typography color={"gray"} fontSize={'13px'} fontWeight={800}> < SettingsIcon/> تنظیمات</Typography> 
      </MenuItem>
                  </Menu>
              <Box
              display={"flex"}
              alignItems={"center"}>
 <IconButton
      size="large"
      edge="end"
      aria-label="account of current user"
      aria-controls={menuId}
      aria-haspopup="true"
      onClick={handleProfileMenuOpen}
      color="inherit"
    >
      {!isMobile && (
        <>
          <Typography
            color={"black"}
            variant="body1"
            fontSize={"13px"}
            fontWeight={900}
          >
            {personName}
          </Typography>
        </>
      )}
      <img
        src={imgSrc}
        width={"25px"}
        height={"25px"}
        style={{ borderRadius: "50%" ,
          marginLeft: isMobile ? '20px' : '0',  // اگر موبایل بود، مارجین 20px می‌شود
        }}
      />
    </IconButton>
            <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={goProfile}>
      <Typography color={"gray"} fontSize={'13px'} fontWeight={800}> <PersonOutlineOutlined />پروفایل </Typography> 
      </MenuItem>
      <Divider variant="middle" />
      <MenuItem 
                  onClick={() => {
                    initiaLogOut();
                  }}
                  color="red"
                  sx={{ fontSize: "0.7 rem", cursor: "pointer" }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "red", fontSize: "13.5px", fontWeight: 900 }}
                  >
                    <ExitIcon />
                    خروج
                  </Typography>
                  </MenuItem>
                  </Menu>
            </Box> 
              <Box display={"flex"}
                flexDirection={"row-reverse"}
                alignItems={"center"}
                textAlign={"center"} > 
              </Box>
              <Box>

              </Box>
            </Box>

            <Box
              display={"flex"}
              justifyContent={"center"}
              width={"100%"}
              textAlign={"center"}
              columnGap={2}
              alignItems={"center"}
            >
              {meetingRoute ? (
                <TenantsList
                  setShowTenantItem={setShowTenantItem}
                  tenantList={tenantList}
                  ButtonCaption={tenantName}
                  pictureBase64String={pictureBase64String}
                />
              ) : 
              <Typography
                  color={"black"}
                  variant="body1"
                  sx={{
                    fontSize: {
                      xs: "10.5px",  // اندازه فونت در موبایل
                      sm: "13px",     // اندازه فونت در وب
                    },
                  }}                  fontWeight={900}
                >
                  {tenantName}
                </Typography>
              }
            </Box>
            
            <Box
              display={"flex"}
              justifyContent={"start"}
              columnGap={2}
              width={"100%"}
              alignItems={"center"}
            >
       <Box>
      {isMobile ? (
              // {!isSidebarOpen && (
                <IconButton
                onClick={toggleSidebar} 
                sx={{
                    // position: "fixed",
                    // top: "10px",
                    // left: "10px",
                    zIndex: 1500,
                    display: { md: "none" }, // فقط در موبایل نمایش داده شود
                  }}
                >
        {isSidebarOpen ? <CloseeIcon /> : <MenuuIcon />} {/* تغییر آیکن بین باز و بسته شدن */}
        </IconButton>
              // )}
        // // در حالت موبایل، آیکون با تولتیپ باز و بسته‌شونده
        // <Tooltip
        //   title={now}
        //   arrow
        //   open={opent}
        //   onClose={handleCloset}
        //   disableFocusListener
        //   disableHoverListener
        //   disableTouchListener
        // >
        //   <IconButton onClick={handleOpent} onBlur={handleCloset} >
        //   <CalendarTodayIcon style={{ color: 'gray' }} />
        //   </IconButton>
        // </Tooltip>
      ) : (
        // در حالت دسکتاپ نمایش مستقیم `now`
        <Typography
          component="div"
          fontWeight={700}
          color={theme.palette.mode === 'dark' ? 'white' : 'black'}
          variant="body2"
        >
          {now}
        </Typography>
      )}
    </Box>
            <Box>
            <IconButton
      size="large"
      edge="end"
      aria-label="account of current user"
      aria-controls={menuId}
      aria-haspopup="true"
      onClick={handleProfileMenuOpennnnn}
      color="inherit"
    >
      {userPhone === "09121223615" && (
        isMobile ? (
          // نمایش آیکون در حالت موبایل
          <DashboardIcoon style={{ color: 'gray' }} />
        ) : (
          // نمایش متن در حالت دسکتاپ
          <Typography
            color="black"
            variant="body1"
            fontSize="13px"
            fontWeight={600}
          >
            مدیریت پنل
          </Typography>
        )
      )}
    </IconButton>
            <Menu
      anchorEl={anchorElllll}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={isMenuOpennnnn}
      onClose={handleMenuCloseeeee}
    >
                  {/* {userPhone === "09121223615" || userPhone === "09101401790" && ( */}
                  {/* {userPhone ===   "09101401790" && ( */}
                  {userPhone ===  "09121223615" && (

      <MenuItem onClick={gotenants}>
      <Typography color={"gray"}  fontSize={'13px'} fontWeight={800}>
        لیست شرکت ها
      </Typography> 
      </MenuItem>
    )}
      {userPhone === "09121223615" && (
      <MenuItem onClick={goIndexManagment}>
      <Typography color={"gray"}  fontSize={'13px'} fontWeight={800}>
        شاخص ها
      </Typography> 
      </MenuItem>
      )}
      {/* <MenuItem >
      <Typography color={"gray"}  fontSize={'13px'} fontWeight={800}>
       دسته بندی 
      </Typography> 
      </MenuItem> */}
      </Menu>
      </Box>


      </Box>

            {/* <Box sx={{display:'flex',flexDirection:'row-reverse'}} alignItems={'center'}  >
              <img src={imgSrc} width={'25px'}  style={{borderRadius:'50%'}}/>
              <Typography  color={'black'}  variant='body1' fontSize={'13px'} fontWeight={900} >
              {personName} 
              </Typography>
              </Box> */}

            {/* toooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooolbar */}
            {/* <Toolbar >
            {locale?.title && (
              <Box sx={{ minWidth: 120, color: "inherit" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">direction</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-selectd"
                    value={locale}
                    renderValue={(val) => val.title}
                    label="Direction"
                    onChange={(event: SelectChangeEvent<MUILocaleData>) => {
                      const data = event.target.value;
                      setLocale(data as MUILocaleData);
                    }}
                  >
                    {supportedLocales.map((item:any) => {
                      return (
                        // @ts-ignore - necessary to load object into value
                        <MenuItem key={item.title} value={item}>
                          {item.title}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Box>
            )}
            <IconButton
              sx={{ fontSize: "1rem" }}
              onClick={toggleColorMode}
              color="inherit"
              disableTouchRipple
              disableRipple
            >
              {theme.palette.mode === "dark" ? (
                <span role="img" aria-label="sun">
                   ☀️
                </span>
              ) : (
                <span role="img" aria-label="moon">
                   🌚
                </span>
              )}
            </IconButton>
          </Toolbar> */}
          </Box>
        </Toolbar>
      </AppBar>

      {/*  variant="persistent" */}
      {/* <Drawer variant="permanent" open={open}>
        <DrawerHeader sx={{ backgroundColor: "#00387C" }}>
          <Box width={"300px"} display={"flex"} alignItems={"center"}>
            <SideBarLogo width={"50px"} style={{ padding: "0px 5px" }} />
            <OKRtext />
          </Box>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon color="info" />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider /> */}
           <IconButton 
        onClick={toggleSidebar} 
        sx={{ position: "fixed", top: "20px", left: "20px", zIndex: 1200 }}
      >
        <MenuIcon />
      </IconButton>

        {isSidebarOpen && (

        <Drawer variant="permanent"  open={!isMobile ? open : true}>
 <DrawerHeader sx={{ backgroundColor: "#00387C" }}>
      <Box
        width={"300px"}
        display={isMobile ? "none" : "flex"} // مخفی کردن در موبایل
        alignItems={"center"}
      >
        <SideBarLogo width={"50px"} style={{ padding: "0px 5px" }} />
        <OKRtext />
      </Box>
      <IconButton onClick={handleDrawerClose}>
        {theme.direction === "rtl" ? (
          <ChevronRightIcon color="info" />
        ) : (
          <ChevronLeftIcon />
        )}
      </IconButton>
    </DrawerHeader>
              {/* )} */}
        <Divider />
     <List
  component={"nav"}
  sx={{
    marginTop: { xs: isLandscape?"0px" : "15%", md: "0px" },
    backgroundColor: "#00387C",
    height: { 
      xs: isLandscape ? "900px" : "100vh", // در حالت افقی موبایل ارتفاع مثل دسکتاپ
      md: "900px" 
    },
    width: { 
      xs: "100vw", 
      md: "300px" 
    }, // عرض کامل صفحه در موبایل
    position: { 
      xs: isMobile ? "fixed" : "relative", // در موبایل موقعیت ثابت شود
      md: "relative" 
    },
    top: 0, 
    left: 0, 
    zIndex: 1000, 
    overflowY: "auto", // اسکرول عمودی برای محتوای طولانی
  }}
>

          {/* {itemsList.map((item, index) => {
            const { text } = item;
            return (
              <ListItem
                color="white " 
                onClick={() => {
                  // console.log(index);
                  setActiveIndex(index);
                }}
                sx={{ fontSize: "0.7 rem" }}
                component={Link}
                to={item.to}
                key={text}
              >
                <ListItemIcon sx={{ color: "white" }}>{item.icon}</ListItemIcon>
                <Typography
                  variant="button"
                  sx={{
                    color: index === activeIndex ? "white" : "white",
                    fontWeight: 600,

                    bgcolor: index === activeIndex ? "#F85700" : "#00387C",
                    borderRadius: 4,
                    width: "100%",

                    p: 0.65,
                  }}
                >
                  {item.text}
                </Typography>
              </ListItem>
            );
          })} */}
                       <List component="div" disablePadding>
        <ListItemButton
          selected={activeIndex === 25}
          onClick={(event) => handleItemClick(event, 25, "/dashboard/TenantDash")}
          sx={{
            color: "white",
            fontWeight: 600,
            backgroundColor: "transparent",
            "&.Mui-selected": {
              backgroundColor: "transparent",
            },
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
          component={Link}
          to={"/dashboard/TenantDash"}
        >
          <ListItemIcon>
          <img src={menuIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
          </ListItemIcon>
          <Typography
            variant="body2"
            pr={8}
            sx={{
              color: "white",
              fontWeight: 600,
              bgcolor: activeIndex === 25 ? "#F85700" : "transparent",
              borderRadius: 4,
              width: "100%",
              p: 0.8,
            }}
          >
            داشبورد
          </Typography>
        </ListItemButton>
      </List>
      <List component="div" disablePadding>
        <ListItemButton
          selected={activeIndex === 18}
          onClick={(event) => handleItemClick(event, 18, "/dashboard/IndexBank")}
          sx={{
            color: "white",
            fontWeight: 600,
            backgroundColor: "transparent",
            "&.Mui-selected": {
              backgroundColor: "transparent",
            },
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
          component={Link}
          to={"/dashboard/IndexBank"}
        >
          <ListItemIcon>
          <img src={BankIcon} alt="bank Icon" style={{ width: 35, height: 35 }} />
          </ListItemIcon>
          <Typography
            variant="body2"
            pr={8}
            sx={{
              color: "white",
              fontWeight: 600,
              bgcolor: activeIndex === 18 ? "#F85700" : "transparent",
              borderRadius: 4,
              width: "100%",
              p: 0.8,
            }}
          >
            بانک شاخص
          </Typography>
        </ListItemButton>
      </List>
{/* <List component="div" disablePadding>
  <ListItemButton
    selected={activeIndex === 18}
    onClick={(event) => {
      event.preventDefault(); // جلوگیری از اقدام روی کلیک
    }}
    sx={{
      color: "lightgray", // تغییر رنگ متن به خاکستری
      fontWeight: 600,
      backgroundColor: "transparent", // پس‌زمینه بدون تغییر
      "&.Mui-selected": {
        backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
      },
      "&:hover": {
        backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
      },
      pointerEvents: 'none', // غیرفعال کردن کلیک
    }}
    component={Link}
    to="#" // لینک را غیرفعال کنید
  >
    <ListItemIcon>
      <img src={BankIcon} alt="bank Icon" style={{ width: 35, height: 35 }} />
    </ListItemIcon>
    <Typography
      variant="body2"
      pr={8}
      sx={{
        color: "lightgray", // رنگ متن برای حالت غیرفعال
        fontWeight: 600,
        bgcolor: "transparent", // پس‌زمینه متن بدون تغییر
        borderRadius: 4,
        width: "100%",
        p: 0.8,
      }}
    >
      بانک شاخص
    </Typography>
  </ListItemButton>
</List> */}

      {/* <List component="div" disablePadding>
        <ListItemButton
          selected={activeIndex === 20}
          onClick={(event) => handleItemClick(event, 20, "/dashboard/MissionAndStrategy")}
          sx={{
            color: "white",
            fontWeight: 600,
            backgroundColor: "transparent",
            "&.Mui-selected": {
              backgroundColor: "transparent",
            },
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
          component={Link}
          to={"/dashboard/MissionAndStrategy"}
        >
          <ListItemIcon>
          <img src={TestingIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
          </ListItemIcon>
          <Typography
            variant="body2"
            pr={8}
            sx={{
              color: "white",
              fontWeight: 600,
              bgcolor: activeIndex === 20 ? "#F85700" : "transparent",
              borderRadius: 4,
              width: "100%",
              p: 0.8,
            }}
          >
            هدف نهایی و استراتژی
          </Typography>
        </ListItemButton>
      </List> */}
      <List component="div" disablePadding>
      <ListItemButton onClick={handleClickkkk} selected={activeIndex === 0} sx={{ color: "white", fontWeight: 600 }}>
        <ListItemIcon>
          <img src={strategyIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
        </ListItemIcon>
        {/* {!isMobile && ( */}
          <Typography variant="body2" pr={9} sx={{ color: "white", fontWeight: 600 }}>
            استراتژی
          </Typography>
        {/* )} */}
        {openItemmmm ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openItemmmm} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
          selected={activeIndex === 1003}
          onClick={(event) => handleItemClick(event, 1003, "/dashboard/MissionAndStrategyMap")}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={"/dashboard/MissionAndStrategyMap"}
            >
          <img src={implementationIcon} alt="Meeting Icon" style={{ width: 32, height: 32 }} />
          <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 1003 ? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
           نقشه استراتژی
            </Typography>
          </ListItemButton>
        </List>

        <List component="div" disablePadding>
          <ListItemButton
          selected={activeIndex === 20}
          onClick={(event) => handleItemClick(event, 20, "/dashboard/MissionAndStrategy")}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={"/dashboard/MissionAndStrategy"}
            >
          <img src={roadmapIcon} alt="Meeting Icon" style={{ width: 32, height: 32 }} />
          <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 20 ? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
            هدف نهایی و استراتژی
            </Typography>
          </ListItemButton>
        </List>
      </Collapse>
    </List>
{/* <List component="div" disablePadding>
  <ListItemButton
    selected={activeIndex === 20}
    onClick={(event) => {
      event.preventDefault(); // جلوگیری از اقدام روی کلیک
    }}
    sx={{
      color: "lightgray", // تغییر رنگ متن به خاکستری
      fontWeight: 600,
      backgroundColor: "transparent", // پس‌زمینه بدون تغییر
      "&.Mui-selected": {
        backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
      },
      "&:hover": {
        backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
      },
      pointerEvents: 'none', // غیرفعال کردن کلیک
    }}
    component={Link}
    to="#" // لینک را غیرفعال کنید
  >
    <ListItemIcon>
      <img src={TestingIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
    </ListItemIcon>
    <Typography
      variant="body2"
      pr={8}
      sx={{
        color: "lightgray", // رنگ متن برای حالت غیرفعال
        fontWeight: 600,
        bgcolor: "transparent", // پس‌زمینه متن بدون تغییر
        borderRadius: 4,
        width: "100%",
        p: 0.8,
      }}
    >
      هدف نهایی و استراتژی
    </Typography>
  </ListItemButton>
</List> */}

    <List component="div" disablePadding>
      <ListItemButton onClick={handleClickk} selected={activeIndex === 0} sx={{ color: "white", fontWeight: 600 }}>
        <ListItemIcon>
          <img src={FolderIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
        </ListItemIcon>
          <Typography variant="body2" pr={6} sx={{ color: "white", fontWeight: 600 }}>
            مدیریت OKR
          </Typography>
        {openItemm ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openItemm} timeout="auto" unmountOnExit>


        <List component="div" disablePadding>
          <ListItemButton
            selected={activeIndex === 11}
            onClick={(event) => handleItemClick(event, 11, "/dashboard/okrManagment")}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={"/dashboard/okrManagment"}
          >
            <img src={BusinessIcon} alt="Meeting Icon" style={{ width: 32, height: 32 }} />
              <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 11 ? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
                اهداف و نتایج کلیدی (OKR)
              </Typography>
          </ListItemButton>
        </List>

        <List component="div" disablePadding>
          <ListItemButton
            selected={activeIndex === 12}
            onClick={(event) => handleItemClick(event, 12, "/dashboard/AllTenantOkrs")}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={"/dashboard/AllTenantOkrs"}
          >
            <img src={BulletIcon} alt="Meeting Icon" style={{ width: 32, height: 32 }} />
              <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 12 ? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
                نمای کلی
              </Typography>
          </ListItemButton>
        </List>

        <List component="div" disablePadding>
          <ListItemButton
            selected={activeIndex === 13}
            onClick={(event) => handleItemClick(event, 13, "/dashboard/VerticalAlignmentPage")}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={"/dashboard/VerticalAlignmentPage"}
          >
            <img src={VerticalIcon} alt="Meeting Icon" style={{ width: 32, height: 32 }} />
              <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 13 ? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
                همسویی عمودی
              </Typography>
          </ListItemButton>
        </List>

        <List component="div" disablePadding>
          <ListItemButton
            selected={activeIndex === 1002}
            onClick={(event) => handleItemClick(event, 1002, "/dashboard/VerticalAlignmentTree")}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={"/dashboard/VerticalAlignmentTree"}
          >
            <img src={HierarchyIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
              <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 1002 ? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
              درخت همسویی عمودی
              </Typography>
          </ListItemButton>
        </List>
        <List component="div" disablePadding>
          <ListItemButton
            selected={activeIndex === 1001}
            onClick={(event) => handleItemClick(event, 1001, "/dashboard/OKRTree")}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={"/dashboard/OKRTree"}
          >
            <img src={HierarchyIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
              <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 1001 ? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
                
                درخت OKR
              </Typography>
          </ListItemButton>
        </List>

      </Collapse>
    </List>

      <List component="div" disablePadding>
        <ListItemButton
          selected={activeIndex === 14}
          onClick={(event) => handleItemClick(event, 14, "/dashboard/indexManaging")}
          sx={{
            color: "white",
            fontWeight: 600,
            backgroundColor: "transparent",
            "&.Mui-selected": {
              backgroundColor: "transparent",
            },
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
          component={Link}
          to={"/dashboard/indexManaging"}
        >
          <ListItemIcon>
          <img src={OptimizatiomIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
          </ListItemIcon>
          <Typography
            variant="body2"
            pr={8}
            sx={{
              color: "white",
              fontWeight: 600,
              bgcolor: activeIndex === 14 ? "#F85700" : "transparent",
              borderRadius: 4,
              width: "100%",
              p: 0.8,
            }}
          >
            مدیریت BAU
          </Typography>
        </ListItemButton>
      </List>
{/* <List component="div" disablePadding>
  <ListItemButton
    selected={activeIndex === 14}
    onClick={(event) => {
      event.preventDefault(); // جلوگیری از اقدام روی کلیک
    }}
    sx={{
      color: "lightgray", // تغییر رنگ متن به رنگ خاکستری روشن
      fontWeight: 600,
      backgroundColor: "transparent", // پس‌زمینه بدون تغییر
      "&.Mui-selected": {
        backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
      },
      "&:hover": {
        backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
      },
      pointerEvents: 'none', // غیرفعال کردن کلیک
    }}
    component={Link}
    to="#" // لینک را غیرفعال کنید
  >
    <ListItemIcon>
      <img src={OptimizatiomIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
    </ListItemIcon>
    <Typography
      variant="body2"
      pr={8}
      sx={{
        color: "lightgray", // رنگ متن برای حالت غیرفعال
        fontWeight: 600,
        bgcolor: "transparent", // پس‌زمینه متن بدون تغییر
        borderRadius: 4,
        width: "100%",
        p: 0.8,
      }}
    >
      مدیریت BAU
    </Typography>
  </ListItemButton>
</List> */}

<List component="div" disablePadding>
  <ListItemButton
    onClick={handleClickkk}
    selected={activeIndex === 0}
    sx={{ color: "white", fontWeight: 600 }}
  >
    <ListItemIcon>
    <img src={MeetingIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
    </ListItemIcon>
    <Typography variant="body2" pr={6} sx={{ color: "white", fontWeight: 600 }}>
      جلسات
    </Typography>
    <ListItemIcon sx={{ marginLeft: '28px',color:"white" }}> {/* اضافه کردن marginLeft برای جابه‌جایی */}
      {openItemmm ? <ExpandLess /> : <ExpandMore />}
    </ListItemIcon>
  </ListItemButton>
  <Collapse in={openItemmm} timeout="auto" unmountOnExit>
  {/* <ListItemButton
  selected={activeIndex === 18}
  onClick={(event) => {
    event.preventDefault(); // جلوگیری از اقدام روی کلیک
  }}
  sx={{
    color: "lightgray", // تغییر رنگ متن به خاکستری
    fontWeight: 600,
    backgroundColor: "transparent", // پس‌زمینه بدون تغییر
    "&.Mui-selected": {
      backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
    },
    "&:hover": {
      backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
    },
    pointerEvents: 'none', // غیرفعال کردن کلیک
  }}
  component={Link}
  to="#" // لینک را غیرفعال کنید
>
  <ListItemIcon>
    <img src={Meet0Icon} alt="Meeting Icon"       style={{
        width: 30,
        height: 30,
        filter: "grayscale(100%) brightness(80%)", // تغییر رنگ تصویر به حالت غیرفعال
      }} />
  </ListItemIcon>

  <Typography
    variant="body2"
    sx={{
      color: "lightgray", // رنگ متن برای حالت غیرفعال
      fontWeight: 600,
      // bgcolor: activeIndex === 30 ? "#F85700" : "transparent", // رنگ پس‌زمینه انتخابی
      bgcolor: "transparent", // پس‌زمینه متن بدون تغییر
      borderRadius: 4,
      width: "100%",
    }}
  >
    
    جلسه تنظیم و ایجاد (Set)
  </Typography>
</ListItemButton> */}

<ListItemButton
  selected={activeIndex === 30}
  onClick={(event) => handleItemClick(event, 30, "/dashboard/alignmentMeeting")}
  sx={{
    color: "white",
    pl: 4,
    fontWeight: 600,
    bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
  }}
  component={Link}
  to={"/dashboard/alignmentMeeting"}
>
    <img src={Meet1Icon} alt="Meeting Icon" style={{ width: 30, height: 30 }} />

  <Typography
    // variant="body2"
    // sx={{
    //   color: "white", // رنگ متن سفید
    //   fontWeight: 600, // ضخامت فونت
    //   fontSize: "11px", // اندازه فونت کوچک‌تر
    //   bgcolor: activeIndex === 30 ? "#F85700" : "transparent", // رنگ پس‌زمینه انتخابی
    //   borderRadius: 4,
    //   width: "100%", // عرض کامل
    //   p: 0.8, // فاصله داخلی
    //   display: "flex",
    //   alignItems: "center", // برای تراز عمودی متن و "(جدید)"
    // }}
    variant="body2"
        // pr={8}
        sx={{
          color: "white",
          fontWeight: 600,
          paddingRight : 300000,
          bgcolor: activeIndex === 30 ? "#F85700" : "transparent",
          borderRadius: 4,
          width: "100%",
          p: 0.8,
        }}
  >
    جلسه همسویی (Alignment)
    {/* <Typography
      component="span"
      sx={{
        color: "red", // رنگ قرمز برای "(جدید)"
        fontWeight: 900,
        marginLeft: 0.2, // فاصله کوچک بین متن اصلی و "(جدید)"
      fontSize: "9px", // اندازه فونت کوچک‌تر

      }}
    >
      (جدید)
    </Typography> */}
  </Typography>
</ListItemButton>

    {/* <ListItemButton
  selected={activeIndex === 18}
  onClick={(event) => {
    event.preventDefault(); // جلوگیری از اقدام روی کلیک
  }}
  sx={{
    color: "lightgray", // تغییر رنگ متن به خاکستری
    fontWeight: 600,
    backgroundColor: "transparent", // پس‌زمینه بدون تغییر
    "&.Mui-selected": {
      backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
    },
    "&:hover": {
      backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
    },
    pointerEvents: 'none', // غیرفعال کردن کلیک
  }}
  component={Link}
  to="#" // لینک را غیرفعال کنید
>
  <ListItemIcon>
    <img src={Meet11Icon} alt="Meeting Icon"      style={{
        width: 30,
        height: 30,
        filter: "grayscale(100%) brightness(80%)", // تغییر رنگ تصویر به حالت غیرفعال
      }} />
  </ListItemIcon>

  <Typography
    variant="body2"
    sx={{
      color: "lightgray", // رنگ متن برای حالت غیرفعال
      fontWeight: 600,
      // bgcolor: activeIndex === 30 ? "#F85700" : "transparent", // رنگ پس‌زمینه انتخابی
      bgcolor: "transparent", // پس‌زمینه متن بدون تغییر
      borderRadius: 4,
      width: "100%",
    }}
  >
        جلسه شروع (Kick-off)
        </Typography>
</ListItemButton> */}

    <ListItemButton
      selected={activeIndex === 15}
      onClick={(event) => handleItemClick(event, 15, "/dashboard/meetings")}
      // sx={{
      //   color: "white",
      //   fontWeight: 600,
      //   backgroundColor: "transparent",
      //   "&.Mui-selected": {
      //     backgroundColor: "transparent",
      //   },
      //   "&:hover": {
      //     backgroundColor: "transparent",
      //   },
      // }}
      // sx={{
      //   color: "white",
      //   pl: 4,
      //   fontWeight: 600,
      //   bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
      // }}
      sx={{
        color: "white",
        display: "flex",
        alignItems: "center", // تراز عمودی متن و آیکون
        pl: 4,
        fontWeight: 600,
        bgcolor: "#0d3e91",
      }}
      component={Link}
      to={"/dashboard/meetings"}
    >
      <ListItemIcon
       sx={{
        minWidth: 0,
        // marginRight: 1,
      }}>
        <img src={Meet21Icon} alt="Meeting Icon" style={{ width: 30, height: 30 }} />
      </ListItemIcon>

      <Typography
        variant="body2"
        pr={8}
        sx={{
          color: "white",
          fontWeight: 600,
          bgcolor: activeIndex === 15 ? "#F85700" : "transparent",
          borderRadius: 4,
          width: "100%",
          p: 0.8,
        }}
      >
        جلسات check_in
      </Typography>
    </ListItemButton>
    {/* <ListItemButton
  selected={activeIndex === 18}
  onClick={(event) => {
    event.preventDefault(); // جلوگیری از اقدام روی کلیک
  }}
  sx={{
    color: "lightgray", // تغییر رنگ متن به خاکستری
    fontWeight: 600,
    backgroundColor: "transparent", // پس‌زمینه بدون تغییر
    "&.Mui-selected": {
      backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
    },
    "&:hover": {
      backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
    },
    pointerEvents: 'none', // غیرفعال کردن کلیک
  }}
  component={Link}
  to="#" // لینک را غیرفعال کنید
    >
      <ListItemIcon>
        <img src={Meet13Icon} alt="Meeting Icon"       style={{
        width: 30,
        height: 30,
        filter: "grayscale(100%) brightness(80%)", // تغییر رنگ تصویر به حالت غیرفعال
      }} />
      </ListItemIcon>
      <Typography
        variant="body2"
        // pr={8}
        sx={{
          color: "lightgray", // رنگ متن برای حالت غیرفعال
          fontWeight: 600,
          // bgcolor: activeIndex === 30 ? "#F85700" : "transparent", // رنگ پس‌زمینه انتخابی
          bgcolor: "transparent", // پس‌زمینه متن بدون تغییر
          borderRadius: 4,
          width: "100%",
        }}
      >
        جلسه جبران شکست
      </Typography>
    </ListItemButton> */}
    {/* <ListItemButton
  selected={activeIndex === 18}
  onClick={(event) => {
    event.preventDefault(); // جلوگیری از اقدام روی کلیک
  }}
  sx={{
    color: "lightgray", // تغییر رنگ متن به خاکستری
    fontWeight: 600,
    backgroundColor: "transparent", // پس‌زمینه بدون تغییر
    "&.Mui-selected": {
      backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
    },
    "&:hover": {
      backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
    },
    pointerEvents: 'none', // غیرفعال کردن کلیک
  }}
  component={Link}
  to="#" // لینک را غیرفعال کنید
    >
      <ListItemIcon>
        <img src={Meet111Icon} alt="Meeting Icon"       style={{
        width: 30,
        height: 30,
        filter: "grayscale(100%) brightness(80%)", // تغییر رنگ تصویر به حالت غیرفعال
      }} />
      </ListItemIcon>

      <Typography
        variant="body2"
        // pr={8}
        sx={{
          color: "lightgray", // رنگ متن برای حالت غیرفعال
          fontWeight: 600,
          // bgcolor: activeIndex === 30 ? "#F85700" : "transparent", // رنگ پس‌زمینه انتخابی
          bgcolor: "transparent", // پس‌زمینه متن بدون تغییر
          borderRadius: 4,
          width: "100%",
        }}
      >
        جلسه موانع
      </Typography>
    </ListItemButton> */}
    {/* <ListItemButton
  selected={activeIndex === 18}
  onClick={(event) => {
    event.preventDefault(); // جلوگیری از اقدام روی کلیک
  }}
  sx={{
    color: "lightgray", // تغییر رنگ متن به خاکستری
    fontWeight: 600,
    backgroundColor: "transparent", // پس‌زمینه بدون تغییر
    "&.Mui-selected": {
      backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
    },
    "&:hover": {
      backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
    },
    pointerEvents: 'none', // غیرفعال کردن کلیک
  }}
  component={Link}
  to="#" // لینک را غیرفعال کنید
    >
      <ListItemIcon>
        <img src={Meet12Icon} alt="Meeting Icon" 
              style={{
                width: 30,
                height: 30,
                filter: "grayscale(100%) brightness(80%)", // تغییر رنگ تصویر به حالت غیرفعال
              }} />
      </ListItemIcon>

      <Typography
        variant="body2"
        // pr={8}
        sx={{
          color: "lightgray", // رنگ متن برای حالت غیرفعال
          fontWeight: 600,
          // bgcolor: activeIndex === 30 ? "#F85700" : "transparent", // رنگ پس‌زمینه انتخابی
          bgcolor: "transparent", // پس‌زمینه متن بدون تغییر
          borderRadius: 4,
          width: "100%",
        }}
      >
        جلسه گذشته نگر (Retro)
      </Typography>
    </ListItemButton> */}
    {/* <ListItemButton
  selected={activeIndex === 18}
  onClick={(event) => {
    event.preventDefault(); // جلوگیری از اقدام روی کلیک
  }}
  sx={{
    color: "lightgray", // تغییر رنگ متن به خاکستری
    fontWeight: 600,
    backgroundColor: "transparent", // پس‌زمینه بدون تغییر
    "&.Mui-selected": {
      backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
    },
    "&:hover": {
      backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
    },
    pointerEvents: 'none', // غیرفعال کردن کلیک
  }}
  component={Link}
  to="#" // لینک را غیرفعال کنید
>
  <ListItemIcon>
    <img
      src={Meet10Icon}
      alt="Meeting Icon"
      style={{
        width: 30,
        height: 30,
        filter: "grayscale(100%) brightness(80%)", // تغییر رنگ تصویر به حالت غیرفعال
      }}
    />
  </ListItemIcon>

  <Typography
    variant="body2"
    sx={{
      color: "lightgray", // رنگ متن برای حالت غیرفعال
      fontWeight: 600,
      bgcolor: "transparent", // پس‌زمینه متن بدون تغییر
      borderRadius: 4,
      width: "100%",
    }}
  >
    جلسه مرور (Review)
  </Typography>
</ListItemButton> */}

    </Collapse>
  </List>

       <List component="div" disablePadding>
        <ListItemButton
          selected={activeIndex === 16}
          onClick={(event) => handleItemClick(event, 16, "/dashboard/report")}
          sx={{
            color: "white",
            fontWeight: 600,
            backgroundColor: "#00387C",
            "&.Mui-selected": {
              backgroundColor: "#00387C",
            },
            "&:hover": {
              backgroundColor: "#00387C",
            },
          }}
          component={Link}
          to={"/dashboard/report"}
        >
          <ListItemIcon>
          <img src={HierarchyIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
          </ListItemIcon>
          <Typography
            variant="body2"
            pr={8}
            sx={{
              color: "white",
              fontWeight: 600,
              bgcolor: activeIndex === 16 ? "#F85700" : "transparent",
              borderRadius: 4,
              width: "100%",
              p: 0.8,
            }}
          >
            گزارشات
          </Typography>
        </ListItemButton>
      </List>
      <List component="div" disablePadding>
      <ListItemButton onClick={handleClickkkkk} selected={activeIndex === 0} sx={{ color: "white", fontWeight: 600 }}>
        <ListItemIcon>
        <img src={CompanyIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
        </ListItemIcon>
          <Typography variant="body2" pr={4.5} sx={{ color: "white", fontWeight: 600 }}>
          مدیریت شرکت
          </Typography>
        {openItemmmmm ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      <Collapse in={openItemmmmm} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
          <ListItemButton
          selected={activeIndex === 33}
          onClick={(event) => handleItemClick(event, 33, "/dashboard/companyManagment/User" )}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={ "/dashboard/companyManagment/User"}
            >
          <img src={teamIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
          <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 33 ? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
             همکاران
            </Typography>
          </ListItemButton>
        </List>
        <List component="div" disablePadding>
          <ListItemButton
          selected={activeIndex === 17}
          onClick={(event) => handleItemClick(event, 17, "/dashboard/companyManagment")}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={"/dashboard/companyManagment"}
            >
          <img src={unitedIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
          <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 17 ? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
            تیم ها 
            </Typography>
          </ListItemButton>
        </List>
        <List component="div" disablePadding>
          <ListItemButton
          selected={activeIndex === 34}
          onClick={(event) => handleItemClick(event, 34, "/dashboard/TenantInfo")}
            sx={{
              color: "white",
              pl: isMobile ? 2 : 4,  // اگر موبایل باشد pl صفر شود
              fontWeight: 600,
              bgcolor: "#0d3e91", // رنگ پس‌زمینه کمرنگ‌تر
            }}
            component={Link}
            to={"/dashboard/TenantInfo"}
            >
          <img src={corporateIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
          <Typography
                variant="body2"
                pr={8}
                sx={{
                  color: "white",
                  fontWeight: 600,
                  bgcolor: activeIndex === 34? "#F85700" : "transparent",
                  borderRadius: 4,
                  width: "100%",
                  fontSize: '11px',
                  p: 0.8,
                }}
              >
             اطلاعات شرکت
            </Typography>
          </ListItemButton>
        </List>
      </Collapse>
    </List>
      {/* <List component="div" disablePadding>
        <ListItemButton
          selected={activeIndex === 17}
          onClick={(event) => handleItemClick(event, 17, "/dashboard/companyManagment")}
          sx={{
            color: "white",
            fontWeight: 600,
            backgroundColor: "#00387C",
            "&.Mui-selected": {
              backgroundColor: "#00387C",
            },
            "&:hover": {
              backgroundColor: "#00387C",
            },
          }}
          component={Link}
          to={"/dashboard/companyManagment"}
        >
          <ListItemIcon>
          <img src={CompanyIcon} alt="Meeting Icon" style={{ width: 35, height: 35 }} />
          </ListItemIcon>
          <Typography
            variant="body2"
            pr={8}
            sx={{
              color: "white",
              fontWeight: 600,
              bgcolor: activeIndex === 17 ? "#F85700" : "transparent",
              borderRadius: 4,
              width: "100%",
              p: 0.8,
            }}
          >
            مدیریت شرکت
          </Typography>
        </ListItemButton>
      </List> */}
      <List component="div" disablePadding>
        <ListItemButton
          selected={activeIndex === 45}
          onClick={(event) => handleItemClick(event, 45, "/dashboard/chat")}
          // sx={{
          //   color: "lightgray", // تغییر رنگ متن به خاکستری
          //   fontWeight: 600,
          //   backgroundColor: "transparent", // پس‌زمینه بدون تغییر
          //   "&.Mui-selected": {
          //     backgroundColor: "transparent", // پس‌زمینه در حالت انتخاب بدون تغییر
          //   },
          //   "&:hover": {
          //     backgroundColor: "transparent", // پس‌زمینه هنگام هاور بدون تغییر
          //   },
          //   pointerEvents: 'none', // غیرفعال کردن کلیک
          // }}
          // component={Link}
          // to="#" // لینک را غیرفعال کنید
        >
          <ListItemIcon>
          <img src={sendIcon} alt="Meeting Icon" style={{ width: 30, height: 30 }} />
          </ListItemIcon>
          <Typography
            variant="body2"
            pr={8}
            sx={{
              color: "white",
              fontWeight: 600,
              bgcolor: activeIndex === 45 ? "#F85700" : "transparent",
              borderRadius: 4,
              width: "100%",
              p: 0.8,
            }}
          >
            چت خصوصی
          </Typography>
        </ListItemButton>
      </List>
{/* 
          {userPhone === "09121223615" && (
            <List
              sx={{ width: "100%", maxWidth: 360 }}
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              <ListItemButton
                onClick={(e: any) => {
                  handleClickk(e);
                }}
                selected={selectedIndexx === 0}
                sx={{ color: "white", fontWeight: 600 }}
              >
                <ListItemIcon>
                  <BaseInfoIcon />
                </ListItemIcon>
                <Typography
                  variant="body2"
                  pr={4}
                  sx={{ color: "white", fontWeight: 600 }}
                >
                  مدیریت پنل
                </Typography>
                {openItemm ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openItemm} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    selected={selectedIndexx === 1}
                    onClick={(event: any) => {
                      handleListItemClickk(event, 1);
                    }}
                    sx={{ pl: 4, color: "white" }}
                    component={Link}
                    to={"/dashboard/tenants"}
                  >
                    <Typography
                      variant="body2"
                      pr={8}
                      sx={{ color: "white", fontWeight: 600 }}
                    >
                      لیست تننت ها
                    </Typography>
                  </ListItemButton>
                </List>
              </Collapse>
            </List>
          )} */}

          {/* 

             <ListItem onClick={()=>{
              initiaLogOut()
             */}
          {/* }} color='white ' sx={{fontSize:'0.7 rem',cursor:'pointer'}}    > */}
          {/* <ListItemIcon sx={{color:'white'}}  >{item.icon}</ListItemIcon> */}
          {/* <Typography variant='body2' sx={{color:'white',fontWeight:600}} >خروج</Typography>
              </ListItem> */}
        </List>

      </Drawer>
                    )}

      <div className="h-[calc(100vh-1rem)] overflow-y-auto w-full scroller " >
        <Box component="main" sx={{ flexGrow: 1 }}>
          {/* <Box>
        <MeetingSlider/>
        </Box> */}
          <DrawerHeader />

          <Outlet />
        </Box>
      </div>
    </Box>
  );
}